import axios from 'axios';
import { getModule, ModuleId } from '@wix/business-manager-api';
import { CONTACTS_WIDGET_DATA_URL } from '../config';

export interface ContactsServiceApi {
  getWidgetData(): any;
}

export class ContactsService implements ContactsServiceApi {
  constructor(private readonly instance) {}

  private get headers() {
    return {
      authorization: this.instance,
    };
  }

  public async getWidgetData() {
    const res = await axios.get(CONTACTS_WIDGET_DATA_URL, {
      headers: this.headers,
    });

    const data = res.data;

    const contactsModule = getModule(ModuleId.Contacts) as any;

    const experiments = contactsModule.getExperiments();
    data.experiments = experiments || {};
    return data;
  }
}
